import Provider from "../Provider";

export default class OcontentProvider extends Provider {
  protected baseUrl = process.env.DATA_URL;
}
